import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import AdminSubmissionsPage from "@/pages/AdminSubmissionsPage";
import ConstructionPage from "@/pages/ConstructionPage";
import ExportPage from "@/pages/ExportPage";
import TechnologyPage from "@/pages/TechnologyPage";
import TeamPage from "@/pages/TeamPage";
import TeamMemberPage from "@/pages/TeamMemberPage";
import HumanResourcesPage from "@/pages/HumanResourcesPage";
import { I18nProvider } from "@/i18n/I18nContext";
import "@/i18n/pages"; // side-effect: extends translations.nav with construction/export/technology
import "@/i18n/extras"; // side-effect: extends translations.nav with hr
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/insaat" element={<ConstructionPage />} />
            <Route path="/construction" element={<ConstructionPage />} />
            <Route path="/ihracat" element={<ExportPage />} />
            <Route path="/export" element={<ExportPage />} />
            <Route path="/teknoloji" element={<TechnologyPage />} />
            <Route path="/technology" element={<TechnologyPage />} />
            <Route path="/ekibimiz" element={<TeamPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/ekibimiz/:slug" element={<TeamMemberPage />} />
            <Route path="/team/:slug" element={<TeamMemberPage />} />
            <Route path="/insan-kaynaklari" element={<HumanResourcesPage />} />
            <Route path="/careers" element={<HumanResourcesPage />} />
            <Route path="/admin/submissions" element={<AdminSubmissionsPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-right"
          richColors
          toastOptions={{
            classNames: {
              toast: "rounded-xl border border-slate-200",
            },
          }}
        />
      </div>
    </I18nProvider>
  );
}

export default App;
